import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Subtitle, Title, Button, List, Link } from './styles';

const getTitle = (district) => {
	if (district.names.length === 2) {
		return `${district.name}: ${district.names.join(' - ')}`;
	}
	return district.name;
}

export default class InterestingDistricts extends React.PureComponent {
	render() {
		return <Wrapper>
			<Title>Senátní volby</Title>
			<Subtitle>Zajímavé souboje</Subtitle>
			<List>
				{this.props.districts.map(district => (
					<li key={district.id}>
						<Link href={`${this.props.link}#/obvod/${district.id}`}>{getTitle(district)}</Link>
					</li>
				))}
			</List>
			{this.props.showMoreBtn && <Button href={this.props.link}>
				Přehled všech obvodů
			</Button>}
		</Wrapper>
	}
}

InterestingDistricts.propTypes = {
	link: PropTypes.string.isRequired,
	districts: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		name: PropTypes.string.isRequired
	})).isRequired
}

InterestingDistricts.defaultProps = {
	showMoreBtn: true
}
